<template>
    <section class="module">
        <div class="container">
            <template v-if="title">
                <h2>{{ title }}</h2>
            </template>
            <slot></slot>
        </div>
    </section>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: ''
        }
    }
}
</script>

<style lang="scss" scoped>
$h2: 24px;

.module {
    padding: 60px 0;
    .container {
        margin: 0 auto;
        width: 1500px;
    }
    h2 {
        padding-bottom: 30px;
        font-size: 24px;
        font-weight: 700;
        text-align: center;
    }
}
</style>